/** Скрытый input[type="file"], открываемый по ref.current?.click(). */
import type { ComponentPropsWithoutRef, Ref } from "react";

type FileInputProps = Omit<ComponentPropsWithoutRef<"input">, "type" | "onChange"> & {
	ref?: Ref<HTMLInputElement>;
	onFile: (file: File) => void;
};

export const FileInput = ({ ref, onFile, className = "hidden", ...props }: FileInputProps) => (
	<input
		ref={ref}
		type="file"
		className={className}
		onChange={(event) => {
			const file = event.target.files?.[0];
			// Сбрасываем значение, чтобы тот же файл можно было выбрать повторно
			event.target.value = "";
			if (file) onFile(file);
		}}
		{...props}
	/>
);
